import { OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutService } from './service/app.layout.service';
import { InsightsService } from '../services/insights.service';

// Menú en 6 secciones ordenadas por frecuencia de uso (design.md §2.1).
const SUBSET = { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' };
const EXACT = { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' };

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {

    model: any[] = [];
    private pendingItem: any = { label: 'Pendientes', icon: 'pi pi-fw pi-inbox', routerLink: ['/pending'], routerLinkActiveOptions: SUBSET, badgeCount: null };
    private sub?: Subscription;

    constructor(public layoutService: LayoutService, private insights: InsightsService) { }

    ngOnInit() {
        this.model = [
            {
                label: 'Inicio',
                items: [
                    { label: 'Resumen', icon: 'pi pi-fw pi-chart-line', routerLink: ['/'], routerLinkActiveOptions: EXACT },
                    this.pendingItem,
                    { label: 'Monitor en vivo', icon: 'pi pi-fw pi-bolt', routerLink: ['/livemap'], routerLinkActiveOptions: SUBSET },
                ]
            },
            {
                label: 'Ventas y clientes',
                items: [
                    { label: 'Reservas', icon: 'pi pi-fw pi-book', routerLink: ['/reservations'], routerLinkActiveOptions: SUBSET },
                    { label: 'Clientes', icon: 'pi pi-fw pi-user', routerLink: ['/customers'], routerLinkActiveOptions: SUBSET },
                    { label: 'Visitas', icon: 'pi pi-fw pi-check-circle', routerLink: ['/visits'], routerLinkActiveOptions: SUBSET },
                    { label: 'Códigos', icon: 'pi pi-fw pi-percentage', routerLink: ['/discount-codes'], routerLinkActiveOptions: SUBSET },
                ]
            },
            {
                label: 'Experiencias',
                items: [
                    { label: 'Eventos', icon: 'pi pi-fw pi-calendar', routerLink: ['/events'], routerLinkActiveOptions: SUBSET },
                    { label: 'Precios del recorrido', icon: 'pi pi-fw pi-dollar', routerLink: ['/pricing'], routerLinkActiveOptions: SUBSET },
                    { label: 'Banners', icon: 'pi pi-fw pi-images', routerLink: ['/banners'], routerLinkActiveOptions: SUBSET },
                ]
            },
            {
                label: 'Bares',
                items: [
                    { label: 'Bares y sucursales', icon: 'pi pi-fw pi-building', routerLink: ['/breweries'], routerLinkActiveOptions: SUBSET },
                    { label: 'Productos', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/products'], routerLinkActiveOptions: SUBSET },
                    { label: 'Usuarios partner', icon: 'pi pi-fw pi-id-card', routerLink: ['/partner-users'], routerLinkActiveOptions: SUBSET },
                    { label: 'Feedback', icon: 'pi pi-fw pi-star', routerLink: ['/feedback'], routerLinkActiveOptions: SUBSET },
                ]
            },
            {
                label: 'Finanzas',
                items: [
                    { label: 'Liquidaciones', icon: 'pi pi-fw pi-calculator', routerLink: ['/branch-settlements'], routerLinkActiveOptions: SUBSET },
                    { label: 'Afiliados', icon: 'pi pi-fw pi-users', routerLink: ['/affiliates'], routerLinkActiveOptions: SUBSET },
                    { label: 'Ingresos por día', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/income'], routerLinkActiveOptions: SUBSET },
                    { label: 'Facturación', icon: 'pi pi-fw pi-file', routerLink: ['/billing'], routerLinkActiveOptions: SUBSET },
                    { label: 'Reporte a partners', icon: 'pi pi-fw pi-file-excel', routerLink: ['/reports'], routerLinkActiveOptions: SUBSET },
                ]
            },
            {
                label: 'Configuración',
                items: [
                    { label: 'Tablas y usuarios admin', icon: 'pi pi-fw pi-cog', routerLink: ['/product-category'], routerLinkActiveOptions: SUBSET },
                ]
            }
        ];
        this.insights.startPendingBadge();
        this.sub = this.insights.pendingCount$.subscribe((n) => (this.pendingItem.badgeCount = n));
    }

    ngOnDestroy() { this.sub?.unsubscribe(); }
}
